<template>
  <div class="modal">
    <!-- Content -->
    <div class="modal-content">
      <!-- Content -->
      <div class="row" style="padding: 0; margin: 0">
        <v-layout row="wrap" align-center px-4 py-3 mb-5>
          <v-flex
            shrink
            class="title-text"
            style="color: #a6cc39; font-size: 27px !important"
            >{{ $t(title) }}</v-flex
          >
          <v-spacer />
          <v-flex shrink>
            <img
              alt
              src="@/assets/imgs/close.jpg"
              style="width: 16px; height: 16px; cursor: pointer"
              @click="close"
            />
          </v-flex>
        </v-layout>
        <div
          class="col-lg-12 form-group"
          style="border-bottom:2px solid #A6CC39;color:#D6C583;padding:0px;8px;"
        >
          <h5 class="title-text" style="color: #a6cc39">
            {{ $t("employeeinformation") }}
          </h5>
        </div>
        <!-- Title -->
        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <div>
            <v-img
              v-if="pathImage"
              :src="pathImage"
              width="180"
              height="180"
              class="mx-auto"
              style="border-radius: 50%; border: 1px solid #c0c0c0"
            ></v-img>
            <v-img
              v-else
              src="@/assets/imgs/defaultprofileimage.jpg"
              alt="header-user"
              height="180px"
              width="180px"
              class="mx-auto"
              style="border-radius: 50%; border: 1px solid #c0c0c0"
            ></v-img>

            <input
              type="file"
              class="d-none"
              ref="file"
              accept="image/*"
              @change="uploadImg($event, 1)"
            />
            <v-btn
              fab
              small
              @click="$refs.file.click()"
              style="
                height: 40px;
                translate: 180px -35px;
                width: 40px;
                left: 31%;
              "
            >
              <v-icon style="color: #a6cc39; font-size: 30px"
                >mdi-square-edit-outline</v-icon
              >
            </v-btn>
          </div>
          <div v-if="checknumber == true" style="color: red" class="text">
            Please fill in Number.
          </div>
        </div>
        <div
          class="col-lg-6 form-group clear mt-4 pr-5 pl-2"
          style="padding-top: 75px"
        >
          <label for="inputEmpID" class="b-text">{{ $t("employeeid") }}</label>
          <input
            autocomplete="off"
            type="text"
            class="form-control"
            id="inputEmpID"
            style="border: 1px solid #707070 !important; border-radius: 10px"
            v-model="empID"
            @keypress="checkEmpNumber($event)"
            @keyup="checkEmpNumber($event)"
            v-mask="
              '###########################################################################'
            "
          />
          <div v-if="checknumber == true" style="color: red" class="text">
            Please fill in Number.
          </div>
        </div>

        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label for="inputFullName" class="b-text">
            {{ $t("fullname") }}
            <span style="color: red">*</span>
          </label>
          <input
            autocomplete="off"
            type="text"
            class="form-control"
            id="inputFullName"
            style="border: 1px solid #707070 !important; border-radius: 10px"
            v-model="empName"
            :style="[namecheck ? { border: ' 1px solid red' } : {}]"
            @change="changeEmpName"
            @keypress="isAlphabat($event, empName)"
            @keydown="isAlphabat($event, empName)"
            @keyup="isAlphabat($event, empName)"
          />
          <div v-if="namecheck" style="color: red" class="text">
            {{ $t("fullname") }} is required
          </div>
          <div v-if="checkfullname" style="color: red" class="text">
            Please fill in alphabet.
          </div>
        </div>

        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label for="inputEmail" class="b-text">
            {{ $t("email") }}
            <span style="color: red">*</span>
          </label>
          <input
            autocomplete="off"
            type="text"
            class="form-control"
            id="inputEmail"
            style="border: 1px solid #707070 !important; border-radius: 10px"
            v-model="email"
            :style="[mailcheck ? { border: ' 1px solid red' } : {}]"
            @change="changeEmail"
          />
          <div v-if="mailcheck" style="color: red" class="text">
            Please enter correct {{ $t("email") }}
          </div>
        </div>

        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label for="inputPosition" class="b-text">
            {{ $t("position") }}
            <span style="color: red">*</span>
          </label>
          <input
            autocomplete="off"
            type="text"
            class="form-control"
            id="inputPosition"
            style="border: 1px solid #707070 !important; border-radius: 10px"
            v-model="position"
            :style="[positioncheck ? { border: ' 1px solid red' } : {}]"
            @change="changePosition"
          />
          <div v-if="positioncheck" style="color: red" class="text">
            {{ $t("position") }} is required
          </div>
        </div>

        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label for="inputrole" class="b-text">
            {{ $t("role") }}
            <span style="color: red">*</span>
          </label>
          <div
            style="border-radius: 10px"
            :style="[rolecheck ? { border: ' 1px solid red' } : {}]"
          >
            <v-select
              v-model="role"
              :value="roleIdforSort(role)"
              :items="items"
              outlined
              dense
              class="role-select"
            ></v-select>
          </div>
          <div v-if="rolecheck" style="color: red" class="text">
            {{ $t("role") }} is required
          </div>
        </div>

        <div
          class="col-lg-12 form-group clear mt-5 pt-4"
          style="border-bottom:2px solid #A6CC39;color:#004A17;padding:0px;8px;"
        >
          <h5 class="title-text" style="color: #a6cc39">
            {{ $t("logincredentials") }}
          </h5>
        </div>

        <div class="col-lg-6 form-group clear mt-4 pr-5 pl-2">
          <label class="b-text" for="inputUserID">
            {{ $t("account") }}
            <span style="color: red">*</span>
          </label>
          <input
            autocomplete="off"
            type="text"
            class="form-control"
            id="inputUserID"
            style="border: 1px solid #707070 !important; border-radius: 10px"
            :style="[useridcheck ? { border: '1px solid red' } : {}]"
            v-model="userID"
          />
          <div v-if="useridcheck" style="color: red" class="text">
            {{ $t("account") }} is required
          </div>
        </div>

        <div
          class="col-lg-6 col-sm-11 col-xs-11 form-group clear mt-4 pr-5 pl-2"
        >
          <label class="b-text" for="inputPassword">
            {{ $t("password") }}
            <span style="color: red">*</span>
          </label>
          <v-text-field
            single
            outlined
            dense
            hide-details
            class="mobile-password"
            v-model="password"
            placeholder="******"
            :append-icon="clkeye ? 'mdi-eye' : 'mdi-eye-off'"
            :type="clkeye ? 'text' : 'password'"
            @click:append="clkeye = !clkeye"
            :style="[passwordcheck ? { border: ' 1px solid red' } : {}]"
            style="border-radius: 10px"
          ></v-text-field>
          <div v-if="passwordcheck" style="color: red" class="text">
            {{ $t("password") }} is required
          </div>
        </div>
      </div>
      <v-layout row="wrap" align-center pt-4 pb-3 mt-5>
        <v-spacer />
        <v-flex md3 px-3>
          <div style="max-width: 240px">
            <v-btn
              block
              class="ma-2"
              @click="close"
              style="color: #707070; text-transform: none"
              text
              >{{ $t("cancel") }}</v-btn
            >
          </div>
        </v-flex>
        <v-flex md3 px-3 v-if="title == 'newemployee'">
          <div style="max-width: 240px">
            <v-btn
              block
              depressed
              @click="Add"
              color="#6CC8A0"
              style="color: white"
              >{{ $t("save") }}</v-btn
            >
          </div>
        </v-flex>
        <v-flex md3 px-3 v-if="title == 'editemployee'">
          <div style="max-width: 240px">
            <v-btn
              block
              depressed
              @click="Update"
              color="#6CC8A0"
              style="color: white"
              >{{ $t("update") }}</v-btn
            >
          </div>
        </v-flex>
      </v-layout>
    </div>
    <v-dialog
      v-model="dialogCrop"
      persistent
      width="600px"
      height="600px"
      overflow="hidden"
    >
      <v-card class="rounded-lg" overflow="hidden">
        <v-card-title
          class="white--text pb-4"
          style="background-color: #a6cc39; font-size: 40px"
          >Crop Image</v-card-title
        >
        <v-card-text
          class="pt-12"
          style="height: 550px; padding-left: 4rem; padding-right: 4rem"
        >
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
          ></vue-cropper>
        </v-card-text>
        <v-card-actions class="mt-3 pb-4" style="margin-right: 50px">
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize font-style"
            outlined
            text
            @click="CancelCrop()"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize font-style reset-btn"
            color="secondary"
            width="80px"
            @click="CropImage()"
            >{{ $t("submit") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#FFF4EB" dark>
        <v-card-text class="black--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#03391F"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isSuccessModalVisible" persistent max-width="438">
      <v-card style="padding: 10px 10px 10px 0">
        <v-card-text>
          <v-layout row="wrap">
            <v-spacer />
            <v-flex
              shrink
              style="cursor: pointer"
              @click="(isSuccessModalVisible = false), reload()"
            >
              <v-img
                src="@/assets/close.svg"
                aspect-ratio="1.7"
                width="14"
                height="14"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text style="padding: 0 27px 0">
          <v-layout align-center>
            <v-flex shrink mr-5>
              <v-img
                src="@/assets/imgs/employee.png"
                aspect-ratio="1.7"
                width="73"
                height="73"
              ></v-img>
            </v-flex>
            <v-flex>
              <p class="alert-text">
                Employee {{ currentModalState }} successfully.
              </p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="#6CC8A0"
            style="color: #fff"
            @click="(isSuccessModalVisible = false), reload()"
            >OK</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isSuccessModalVisible" max-width="438">
      <v-card style="padding: 10px 10px 10px 0">
        <v-card-text>
          <v-layout row="wrap">
            <v-spacer />
            <v-flex
              shrink
              style="cursor: pointer"
              @click="(isSuccessModalVisible = false), reload()"
            >
              <v-img
                src="@/assets/close.svg"
                aspect-ratio="1.7"
                width="14"
                height="14"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text style="padding: 0 27px 0">
          <v-layout align-center>
            <v-flex shrink mr-5>
              <v-img
                src="@/assets/imgs/employee.png"
                aspect-ratio="1.7"
                width="73"
                height="73"
              ></v-img>
            </v-flex>
            <v-flex>
              <p class="alert-text">
                Employee {{ currentModalState }} successfully.
              </p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="#6CC8A0"
            style="color: #fff"
            @click="(isSuccessModalVisible = false), reload()"
            >OK</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalWarning
      :warningModal="warningModal"
      @warningModalUpdate="warningModal = warningModalUpdate"
    />
  </div>
</template>

<script>
import GlobalMixin from "../Mixins/GlobalMixin";
import ModalWarning from "../../components/ModalWarning";
import axios from "axios";
import enurl from "@/api/environment";
import { VueCropper } from "vue-cropper";
export default {
  name: "Modal",
  components: {
    ModalWarning,
    VueCropper
  },
  mixins: [GlobalMixin],
  props: {
    title: String,
    companyID: String,
    employeeID: String,
    empID: String,
    empName: String,
    /////Noted(Reopen)/////////////////
    pathImage: String,
    email: String,
    position: String,
    role: Number,
    userID: String,
    password: String,
    lockstatus: Boolean,
    check_Id: Number
  },
  data: () => ({
    prefix: "",
    profileImage: "",
    fileName: "",
    fileUrl: "",
    file: null,
    dialogCrop: false,
    option: {
      img: "",
      size: 1,
      full: false,
      outputType: "png",
      canMove: true,
      fixedBox: true,
      original: false,
      canMoveBox: false,
      autoCrop: true,
      autoCropWidth: 800,
      autoCropHeight: 450,
      centerBox: false,
      high: true
    },
    items: [
      { text: "Employee", value: 1 },
      { text: "HR", value: 2 },
      { text: "Admin", value: 3 }
    ],
    clkeye: true,
    warningModal: false,
    isSuccessModalVisible: false,
    currentModalState: null,
    url: enurl.apiUrl,
    size: 10,
    dialog: false,
    characters: "a-z,A-Z,0-9",
    namecheck: false,
    mailcheck: false,
    positioncheck: false,
    rolecheck: false,
    useridcheck: false,
    passwordcheck: false,
    checknumber: false,
    checkfullname: false,
    changeEmpNameStatus: false,
    changeEmailStatus: false,
    changePositionStatus: false,
    changeRoleStatus: false
  }),
  methods: {
    getFile(e) {
      this.fileUrl = e;
      this.file = e;
      this.pathImage = e;
    },
    CropImage() {
      this.$refs.cropper.getCropData(data => {
        this.getFile(data);
        this.dialogCrop = false;
      });
    },
    CancelCrop() {
      this.dialogCrop = false;
    },
    uploadImg(e, num) {
      let self = this;
      let file = e.target.files[0];
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("Please choose image!");
        return false;
      }
      this.fileName = file.name;
      let reader = new FileReader();
      reader.onload = e => {
        let data;
        if (typeof e.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        if (num === 1) {
          self.option.img = data;
          self.dialogCrop = true;
        } else if (num === 2) {
          console.log("something wrong.");
        }
      };
      reader.readAsArrayBuffer(file);
    },
    roleIdforSort(v) {
      if (v == 1) return 2;
      if (v == 2) return 3;
      if (v == 3) return 1;
    },
    lockFunction() {
      this.lockstatus = !this.lockstatus;
    },
    roleNametoId(v) {
      if (v == "Employee") return 1;
      if (v == "HR") return 2;
      if (v == "Admin") return 3;
    },
    reload() {
      window.location.reload();
    },
    isAlphabat(evt, name) {
      if (!/^[a-zA-Z\s]+$/.test(name)) {
        return (this.empName = name.replace(/[0-9]/g, ""));
      }
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      if (
        charCode < 65 &&
        (charCode > 90 || charCode < 97) &&
        charCode !== 32 &&
        charCode != 8 &&
        charCode != 46
      ) {
        this.checkfullname = true;
        evt.preventDefault();
      } else {
        this.checkfullname = false;
      }
      if (
        charCode == 17 ||
        charCode == 86 ||
        charCode == 9 ||
        charCode == 18 ||
        charCode == 16 ||
        charCode == 20
      ) {
        this.checkfullname = false;
      }
      if (evt.keyCode == 90 && evt.ctrlKey === true) {
        this.checkfullname = false;
      }
      for (let nam = 68; nam <= 105; nam++) {
        if (evt.key == nam) {
          this.checkfullname = true;
        }
      }
      if (
        evt.key == "0" ||
        evt.key == "1" ||
        evt.key == "2" ||
        evt.key == "3" ||
        evt.key == "4" ||
        evt.key == "5" ||
        evt.key == "6" ||
        evt.key == "7" ||
        evt.key == "8" ||
        evt.key == "9"
      ) {
        return (this.checkfullname = true);
      }
    },
    close() {
      this.$emit("close");
      this.namecheck = false;
      this.checkfullname = false;
      this.mailcheck = false;
      this.positioncheck = false;
      this.rolecheck = false;
      this.useridcheck = false;
      this.passwordcheck = false;
    },
    checkEmpNumber(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode >= 65 && charCode <= 90) {
        this.checknumber = true;
      } else if (event.key >= 0 && event.key <= 9) {
        this.checknumber = false;
      } else {
        this.checknumber = false;
      }
    },
    /*  close() {
      this.$emit("close");

      //window.location.reload();
    }, */
    validateEmail(email) {
      //////Noted(Reopne)/////////////////////
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line

      return re.test(email);
    },
    async Add() {
      let self = this;
      let base64Res;
      if (!self.validation_user_management()) {
        self.warningModal = true;
      }
      self.dialog = false;
      if (self.checkvalidate()) {
        let aa = self.validateEmail(self.email);
        if (aa === true) {
          self.mailcheck = false;

          base64Res = await axios.post(`${self.url}File/UploadFileStringBase`, {
            base64: self.file,
            fileName: self.fileName
          });
          let temp = {
            username: self.userID,
            password: self.password,
            agentID: 0,
            roleId: self.role,
            idcard: 0,
            prefixId: 0,
            firstName: self.empName,
            mobile: "",
            email: self.email,
            insertByUserId: "",
            salarid: 0,
            startWorkDate: null,
            supervisorID: 0,
            userRole: 0,
            positions: self.position,
            createBy: "Admin",
            updateBy: "Admin",
            companyId: self.companyID,
            empID: self.empID,
            pathImage: base64Res.data
          };

          self.dialog = true;
          axios
            .post(`${self.url}EmployeeCom/AddEmployeeCom`, temp)
            .then(function(response) {
              self.dialog = false;
              if (response.data.status == 0) {
                self.isSuccessModalVisible = true;
                self.currentModalState = "saved";
                self.dialog = false;
              } else {
                alert("User ID already existed");
                self.dialog = false;
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          self.dialog = false;
          self.mailcheck = true;
        }
      }
    },
    checkvalidate() {
      let self = this;
      self.namecheck = true;
      self.mailcheck = true;
      self.positioncheck = true;
      self.rolecheck = true;
      self.useridcheck = true;
      self.passwordcheck = true;

      let returnvalue = true;

      if (self.empName != "" && self.empName != undefined) {
        self.namecheck = false;
      } else {
        returnvalue = false;
      }
      if (self.email != "" && self.email != undefined) {
        self.mailcheck = false;
        let aa = self.validateEmail(self.email);
        if (!aa) {
          returnvalue = false;
          self.mailcheck = true;
        }
      } else {
        returnvalue = false;
      }
      if (self.position != "" && self.position != undefined) {
        self.positioncheck = false;
      } else {
        returnvalue = false;
      }
      if (self.role != "" && self.role != undefined) {
        self.rolecheck = false;
      } else {
        returnvalue = false;
      }
      if (self.userID != "" && self.userID != undefined) {
        self.useridcheck = false;
      } else {
        returnvalue = false;
      }
      if (self.password != "" && self.password != undefined) {
        self.passwordcheck = false;
      } else {
        returnvalue = false;
      }
      return returnvalue;
    },
    checkvalidate1() {
      let self = this;
      self.namecheck = true;
      self.mailcheck = true;
      self.positioncheck = true;
      self.rolecheck = true;
      self.useridcheck = true;

      let returnvalue = true;

      if (self.empName != "" && self.empName != undefined) {
        self.namecheck = false;
      } else {
        returnvalue = false;
      }
      if (self.email != "" && self.email != undefined) {
        self.mailcheck = false;
        let aa = self.validateEmail(self.email);
        if (!aa) {
          returnvalue = false;
          self.mailcheck = true;
        }
      } else {
        returnvalue = false;
      }
      if (self.position != "" && self.position != undefined) {
        self.positioncheck = false;
      } else {
        returnvalue = false;
      }
      if (self.role != "" && self.role != undefined) {
        self.rolecheck = false;
      } else {
        returnvalue = false;
      }
      if (self.userID != "" && self.userID != undefined) {
        self.useridcheck = false;
      } else {
        returnvalue = false;
      }
      return returnvalue;
    },
    async Update() {
      let self = this;
      let base64Res;

      if (!self.validation_user_management1()) {
        self.warningModal = true;
      }
      self.dialog = false;
      if (self.checkvalidate1()) {
        base64Res = await axios.post(`${self.url}File/UploadFileStringBase`, {
          base64: self.file,
          fileName: self.fileName
        });
        let temp = {
          employeeCOMId: self.employeeID,
          username: self.userID,
          password: self.password,
          agentID: 0,
          roleId: self.role,
          userType: "string",
          idcard: 0,
          prefixId: 0,
          firstName: self.empName,
          mobile: null,
          email: self.email,
          pathImage: base64Res.data,
          updatedByUserId: "",
          salaryid: 0,
          startWorkDate: null,
          supervisorID: 0,
          userRole: 0,
          positions: self.position,
          empID: self.empID,
          createBy: "Admin",
          updateBy: "Admin",
          companyId: self.companyID,
          lockstatus: self.lockstatus
        };
        self.dialog = true;
        axios
          .post(`${self.url}EmployeeCom/UpdateEmployeeCOM`, temp)
          .then(function(response) {
            if (response.data.status == 0) {
              if (self.check_Id == self.$store.getters.userid) {
                sessionStorage.setItem("position", self.position);
                sessionStorage.setItem("userImage", self.pathImage);
              }

              self.dialog = false;
              self.isSuccessModalVisible = true;
              self.currentModalState = "updated";
            } else {
              alert("Employee name already existed");
              self.dialog = false;
            }
          })
          .catch(function(error) {
            self.dialog = false;
            console.log(error);
          });
      }
    },
    changeEmpName() {
      this.changeEmpNameStatus = true;
    },
    changeEmail() {
      this.changeEmailStatus = true;
    },
    changePosition() {
      this.changePositionStatus = true;
    },
    changeRole() {
      this.changeRoleStatus = true;
    },
    Reset() {
      let self = this;
      if (self.changeEmpNameStatus) self.empName = "";
      if (self.changeRoleStatus) self.role = "1";
      if (self.changePositionStatus) self.position = "";
      if (self.changeEmailStatus) self.email = "";
    },
    ResetPass() {
      let charactersArray = this.characters.split(",");
      let CharacterSet = "";
      let tempPassword = "";

      if (charactersArray.indexOf("a-z") >= 0) {
        CharacterSet += "abcdefghijklmnopqrstuvwxyz";
      }
      if (charactersArray.indexOf("A-Z") >= 0) {
        CharacterSet += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      }
      if (charactersArray.indexOf("0-9") >= 0) {
        CharacterSet += "0123456789";
      }
      if (charactersArray.indexOf("#") >= 0) {
        CharacterSet += "![]{}()%&*$#^<>~@|";
      }

      for (let i = 0; i < this.size; i++) {
        tempPassword += CharacterSet.charAt(
          Math.floor(Math.random() * CharacterSet.length)
        );
      }
      this.password = tempPassword;
    }
  },
  watch: {
    empName: function() {
      this.namecheck = false;
    },
    email: function() {
      this.mailcheck = false;
    },
    position: function() {
      this.positioncheck = false;
    },
    role: function() {
      this.rolecheck = false;
    },
    userID: function() {
      this.useridcheck = false;
    },
    password: function() {
      this.passwordcheck = false;
    }
  }
};
</script>

<style scoped>
::v-deep .v-input__slot {
  border-radius: 10px !important;
  height: 30px !important;
}
::v-deep .v-input__control {
  height: 40px !important;
}
.role-select.theme--light.v-text-field--outlined fieldset {
  border-color: red;
  height: 58px;
  top: -7px;
}
.modal {
  display: block;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}
.modal-content {
  background-color: #fefefe;
  margin: 5% auto;
  padding: 30px 40px 15px 40px;
  border: 1px solid #888;
  width: 65%;
  border-radius: 25px;
}
@media only screen and (max-width: 600px) {
  .modal-content {
    width: 90%;
    padding: 30px 20px 15px 20px;
  }
}

@media only screen and (max-width: 414px) {
  .mobile-password {
    margin-left: 0 !important;
  }
}

@media only screen and (max-width: 375px) {
  .mobile-password {
    margin-left: 0 !important;
  }
}
.modal-content .close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}
.modal-content .close:hover,
.modal-content .close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.form-group label {
  color: #43425d;
}

.form-group label {
  color: #43425d;
}
.form-group input,
.input-group input {
  /* color: rgba(77, 79, 92, 0.4);  */
  border: 1px solid #e8e9ec;
}
.form-group select,
.input-group select {
  /* color: rgba(77, 79, 92, 0.4);  */
  border: 1px solid #e8e9ec;
}
.form-group textarea,
.input-group textarea {
  /*  color: rgba(77, 79, 92, 0.4); */
  border: 1px solid #e8e9ec;
}
.form-group-content {
  padding: 20px 0 10px 4px;
}
.review-box {
  position: relative;
  margin-left: 25px;
  margin-right: 15px;
  padding: 30px 40px;
  border: 1px solid #ecebee;
  font-size: 4rem;
  border-radius: 4px;
}
.review-box i {
  color: rgba(67, 66, 93, 0.2);
}
.review-box .close {
  position: absolute;
  top: -10px;
  right: -10px;
  float: right;
}
.review-box .close i {
  font-size: 28px;
  color: #eb2127;
}
.review-box .close:hover i {
  color: #eb2127;
}

.modal-footer button {
  outline: none;
}
</style>
<style>
.role-select .v-select__selections {
  height: 44px;
}
.modal {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.modal::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
</style>
